<template>
    <circle cx="12.5" cy="12.5001" r="8.5" stroke="#D82A1F" stroke-width="2"
            stroke-linecap="round"></circle>
    <path d="M18.316 6.23694L7.13184 18.7633" stroke="#D82A1F" stroke-width="2"></path>
</template>

<script>
    export default {
        name: 'icon-cancel'
    }
</script>